import styled from 'styled-components';

export const DropdownDiv = styled.div`
  position: relative;
  font-size: 14px;
  cursor: pointer;
  .header {
    display: flex;
    padding: 8px;
    align-items: center;
    font-size: 14px;
    font-family: 'Montserrat Regular';
    border-bottom: unset;
    height: 35px;

    .header-icon {
      margin-right: 8px;
      height: 16px;
      width: 16px;
    }
    .header-title {
      color: var(--grey-95);
    }
  }

  .header-with-dropdown-icon {
    border-radius: 8px;
    background: #fff;
    display: flex;
    padding: 8px;
    align-items: center;
    gap: 8px;
    justify-content: space-between;

    .rotate {
      transform: rotate(180deg);
    }
  }

  .right {
    right: 0;
  }
  .left {
    left: 0;
  }

  .menu {
    position: absolute;
    top: 40px;
    z-index: 10;
    border-radius: 8px;
    background: #fff;
    margin-bottom: 8px;


    .menu-toggle-item {
      display: flex;
      justify-content: space-between;
    }

    .menu-item {
      padding: 8px 16px;
      min-width: 224px;
      min-height: 32px;
      background-color: white;
      color: var(--grey-95);
      border-right: 1px solid var(--grey-20, #C9CBCF);
      border-left:  1px solid var(--grey-20, #C9CBCF);
      .icon {
        margin-right: 8px;
        height: 17px;
        width: 17px;
      }
    }
    .menu-item:hover {
      background: var(--grey-2);
      color: var(--grey-95);
    }
    .menu-item-last {
      border-radius: 0px 0px 8px 8px;
      border-bottom: 1px solid var(--grey-20, #C9CBCF);
    }

    .menu-item-first {
      border-radius: 8px 8px 0px 0px;
      border-top: 1px solid var(--grey-20, #C9CBCF);
    }

    .menu-item:hover {
      background: var(--blue-5);
      color: var(--grey-95);
    }

    .menu-item-active {
      background: var(--blue-50);
      color: #fff;
    }
    .menu-item.menu-item-active:hover {
      background: var(--blue-50); /* Change to whatever styles you want to apply when hovering is disabled */
      color: #fff;
    }
  }

  // Toggle
  .toggle-with-label {
    display: flex;
    align-items: center;
  }

  .toggle-label {
    padding-right: 8px;
  }

  .toggle-switch {
    position: relative;
    width: 22px;
  }

  .toggle-switch-checkbox {
    display: none !important;
  }

  .toggle-switch-label {
    display: block;
    overflow: hidden;
    cursor: pointer;
    // border: 2px solid #999999;
    border-radius: 8px;
    height: 14px;
  }

  .toggle-switch-inner {
    display: block;
    width: 200%;
    margin-left: -100%;
    transition: margin 0.3s ease-in 0s;

    &:before,
    &:after {
      display: block;
      float: left;
      width: 50%;
      height: 24px;
      padding: 0;
      line-height: 24px;
      font-size: 12px;
      color: white;
      font-weight: bold;
      box-sizing: border-box;
    }

    &:before {
      content: '';
      padding-left: 20px;
      background-color: var(--blue-50);
      color: #ffffff;
    }

    &:after {
      content: '';
      padding-right: 20px;
      background-color: #bbbbbb;
      color: #ffffff;
      text-align: right;
    }
  }

  .toggle-switch-switch {
    display: block;
    margin: 1px;
    background: #ffffff;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 7px;
    // border: 2px solid #999999;
    border-radius: 50%;
    transition: all 0.3s ease-in 0s;
    height: 12px;
    width: 12px;
  }

  .toggle-switch-checkbox:checked + .toggle-switch-label .toggle-switch-inner {
    margin-left: 0;
  }

  .toggle-switch-checkbox:checked + .toggle-switch-label .toggle-switch-switch {
    right: 0px;
  }
`;